import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Phone, BadgeCheck } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const IKONS_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/5mudso8d_IMG_9412.png";

const initialForm = { name: "", email: "", organization: "", message: "" };

export default function Contacto() {
  const [form, setForm] = useState(initialForm);
  const [sending, setSending] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Mensaje enviado. La representación te contactará pronto.");
      setForm(initialForm);
    } catch (err) {
      toast.error("No se pudo enviar el mensaje. Intenta nuevamente.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contacto" data-testid="contacto-section" className="relative py-28 px-6 border-t border-neutral-900">
      <div className="max-w-6xl mx-auto">
        <SectionHead eyebrow="06 — Contacto" title="Representación profesional" testId="contacto-title" />

        <div className="mt-14 grid lg:grid-cols-5 gap-6">
          <Reveal className="lg:col-span-2 border border-neutral-800 bg-[#0f0f0f] p-8 flex flex-col justify-between min-h-[320px]">
            <div>
              <p className="font-tech text-xs uppercase tracking-[0.35em] text-neutral-500">Agencia</p>
              <div className="mt-4 bg-white px-6 py-4 inline-block" data-testid="agent-agency-logo">
                <img src={IKONS_LOGO} alt="Ikons by Solocracks" className="h-16 w-auto" />
              </div>
              <p className="text-sm text-neutral-400 mt-5 leading-relaxed">
                Para propuestas deportivas, prensa o alianzas comerciales,
                contacta directamente a la representación del jugador.
              </p>
            </div>
            <ul className="space-y-3 mt-8 font-tech text-sm">
              <li className="flex items-center gap-3 text-neutral-300" data-testid="agent-name">
                <BadgeCheck size={16} className="text-[#d4af37]" />
                Edgar Merino
                <span className="text-[10px] uppercase tracking-widest border border-[#d4af37]/50 text-[#d4af37] px-2 py-0.5">Agente FIFA</span>
              </li>
              <li className="flex items-center gap-3 text-neutral-300" data-testid="agent-email">
                <Mail size={16} className="text-[#d4af37]" />
                <a href="mailto:merinovidangossy@gmail.com" className="hover:text-[#d4af37] transition-colors">merinovidangossy@gmail.com</a>
              </li>
              <li className="flex items-center gap-3 text-neutral-300" data-testid="agent-phone">
                <Phone size={16} className="text-[#d4af37]" />
                <a href="tel:+34665497561" className="hover:text-[#d4af37] transition-colors">+34 665 497 561</a>
              </li>
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-3 border border-neutral-800 bg-[#0f0f0f] p-8">
            <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4" data-testid="contact-form">
              <input
                required
                data-testid="contact-name-input"
                value={form.name}
                onChange={update("name")}
                placeholder="Nombre"
                className="bg-[#050505] border border-neutral-800 px-4 py-3 text-sm placeholder:text-neutral-600 focus:border-[#d4af37] focus:outline-none transition-colors"
              />
              <input
                required
                type="email"
                data-testid="contact-email-input"
                value={form.email}
                onChange={update("email")}
                placeholder="Email"
                className="bg-[#050505] border border-neutral-800 px-4 py-3 text-sm placeholder:text-neutral-600 focus:border-[#d4af37] focus:outline-none transition-colors"
              />
              <input
                data-testid="contact-organization-input"
                value={form.organization}
                onChange={update("organization")}
                placeholder="Club / Organización"
                className="sm:col-span-2 bg-[#050505] border border-neutral-800 px-4 py-3 text-sm placeholder:text-neutral-600 focus:border-[#d4af37] focus:outline-none transition-colors"
              />
              <textarea
                required
                rows={5}
                data-testid="contact-message-input"
                value={form.message}
                onChange={update("message")}
                placeholder="Mensaje"
                className="sm:col-span-2 bg-[#050505] border border-neutral-800 px-4 py-3 text-sm placeholder:text-neutral-600 focus:border-[#d4af37] focus:outline-none transition-colors resize-none"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="contact-submit-button"
                className="sm:col-span-2 font-tech text-xs uppercase tracking-[0.25em] bg-white text-black px-8 py-4 hover:bg-[#d4af37] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sending ? "Enviando…" : "Enviar Mensaje →"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
